import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockSliderModule } from '@common/components/feature-part/block-slider/block-slider.module';
import { AmountFormatModule, DateFormatModule, StaticMsgModule } from '@lib/pipes';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentDetailS01P031Component } from './payment-detail-s01-p031.component';
import { PaymentItemModule } from './payment-item/payment-item.module';
import { MilesFormatModule } from '@common/pipes/miles-format/miles-format.module';

@NgModule({
  declarations: [PaymentDetailS01P031Component],
  exports: [PaymentDetailS01P031Component],
  imports: [
    CommonModule,
    BlockSliderModule,
    StaticMsgModule,
    AmountFormatModule,
    MilesFormatModule,
    DateFormatModule,
    TranslateModule,
    PaymentItemModule,
  ],
})
export class PaymentDetailS01P031Module {}
